/* Noom — advertoriale noom-stopy-*. Filmy: wyciszona pętla bez kontrolek, gra tylko w widoku; galeria i przycisk sekcji zakupowej. */
(() => {
  'use strict';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const videos = new Set();
  const state = new WeakMap();
  const firstFrame = ['loadeddata', 'suspend', 'stalled', 'error'];

  // Gra, gdy ≥ 25% filmu jest w widoku, karta jest widoczna i (przy reduced motion) użytkownik sam go włączył.
  const wanted = (video) => {
    const s = state.get(video);
    return !!s && s.visible && !document.hidden && (!reduced.matches || s.chosen);
  };

  function play(video) {
    const s = state.get(video);
    if (!s || !wanted(video) || !video.paused || s.pending) return;
    // Film, który już się buforuje, startuje od pierwszej klatki — Safari zostawia wtedy poster zamiast pustej ramki.
    if (video.readyState < 2 && video.networkState === 2 && !s.waited) {
      s.pending = true;
      s.waited = true;
      const go = () => {
        firstFrame.forEach((type) => video.removeEventListener(type, go));
        s.pending = false;
        play(video);
      };
      firstFrame.forEach((type) => video.addEventListener(type, go));
      return;
    }
    const settle = (error) => {
      s.pending = false;
      s.blocked = !!error && error.name === 'NotAllowedError';
      if (!error && !wanted(video)) video.pause();
    };
    video.muted = true;
    s.pending = true;
    try {
      const request = video.play();
      if (request && typeof request.then === 'function') request.then(() => settle(), settle);
      else settle();
    } catch (error) {
      settle(error);
    }
  }

  const sync = (video) => {
    if (wanted(video)) play(video);
    else if (!video.paused) video.pause();
  };
  const syncAll = () => videos.forEach(sync);
  const setVisible = (video, visible) => {
    const s = state.get(video);
    if (!s) return;
    s.visible = visible;
    if (!visible) s.chosen = false;
    sync(video);
  };

  // Bufor ok. jeden ekran przed filmem; decyzja o odtwarzaniu przy 25% widoczności.
  const hasIO = 'IntersectionObserver' in window;
  const warm = hasIO ? new IntersectionObserver((entries) => entries.forEach(({ target, isIntersecting }) => {
    if (isIntersecting && !reduced.matches) {
      target.preload = 'auto';
      warm.unobserve(target);
    }
  }), { rootMargin: '100% 0px' }) : null;
  const observer = hasIO ? new IntersectionObserver((entries) => entries.forEach((entry) => {
    if (!entry.target.isConnected) forget(entry.target);
    else setVisible(entry.target, entry.isIntersecting && entry.intersectionRatio >= 0.25);
  }), { threshold: [0, 0.25, 0.5] }) : null;

  let frame = 0;
  const measure = () => {
    frame = 0;
    videos.forEach((video) => {
      const r = video.getBoundingClientRect();
      const seen = Math.min(r.bottom, innerHeight) - Math.max(r.top, 0);
      setVisible(video, r.height > 0 && seen >= r.height * 0.25);
    });
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(measure); };

  function forget(video) {
    if (!state.has(video)) return;
    if (observer) { observer.unobserve(video); warm.unobserve(video); }
    videos.delete(video);
    state.delete(video);
    video.pause();
  }

  function track(video) {
    if (state.has(video)) return;
    state.set(video, { visible: false, chosen: false, pending: false, blocked: false, waited: false });
    videos.add(video);
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.playsInline = true;
    video.controls = false;
    video.disablePictureInPicture = true;
    if (reduced.matches && video.autoplay) {
      // Reduced motion: hero z atrybutem autoplay wraca na poster i czeka na dotknięcie.
      video.autoplay = false;
      video.pause();
      if (video.currentTime > 0 || video.readyState > 0) video.load();
    }
    if (observer) { observer.observe(video); warm.observe(video); } else schedule();
  }

  function init(root) {
    root.querySelectorAll('[data-ns-video] video').forEach(track);

    // Menu mobilne: zamknij po wyborze pozycji.
    root.querySelectorAll('.nav-toggle').forEach((toggle) => {
      toggle.addEventListener('click', (event) => {
        if (event.target.closest('a')) toggle.open = false;
      });
    });

    // Sekcja zakupowa: galeria (strzałki, miniatury, licznik) — bez JS zdjęcia i tak przewijają się palcem.
    root.querySelectorAll('[data-ns-gal]').forEach(gallery);
    // „Kup teraz”: formularz sam dodaje do koszyka i otwiera kasę; tu tylko informacja o przejściu i blokada drugiego kliknięcia.
    root.querySelectorAll('[data-ns-buy]').forEach((form) => {
      form.addEventListener('submit', (event) => {
        const button = form.querySelector('.ns-buy-atc');
        if (!button) return;
        if (button.classList.contains('is-loading')) { event.preventDefault(); return; }
        button.classList.add('is-loading');
        button.setAttribute('aria-busy', 'true');
        const label = button.querySelector('[data-ns-label]');
        if (label && button.dataset.loading) { label.dataset.text = label.textContent; label.textContent = button.dataset.loading; }
      });
    });

    // FAQ: jedna odpowiedź otwarta naraz.
    root.querySelectorAll('.disclosures').forEach((group) => {
      group.addEventListener('toggle', (event) => {
        const opened = event.target;
        if (!(opened instanceof HTMLDetailsElement) || !opened.open) return;
        group.querySelectorAll('details[open]').forEach((item) => { if (item !== opened) item.open = false; });
      }, true);
    });
  }

  function gallery(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    const track = el.querySelector('[data-ns-track]');
    if (!track || track.children.length < 2) return;
    const total = track.children.length;
    const prev = el.querySelector('[data-ns-prev]');
    const next = el.querySelector('[data-ns-next]');
    const count = el.querySelector('[data-ns-count]');
    const thumbs = [...el.querySelectorAll('[data-ns-thumb]')];
    el.querySelectorAll('[data-ns-prev], [data-ns-next], [data-ns-thumbs]').forEach((node) => { node.hidden = false; });
    let index = -1;
    const go = (i) => track.scrollTo({ left: Math.max(0, Math.min(total - 1, i)) * track.clientWidth, behavior: reduced.matches ? 'auto' : 'smooth' });
    const update = () => {
      const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (i === index) return;
      index = i;
      if (count) count.textContent = `${i + 1} / ${total}`;
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= total - 1;
      thumbs.forEach((thumb, n) => thumb.setAttribute('aria-current', n === i ? 'true' : 'false'));
    };
    let ticking = false;
    track.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => { ticking = false; update(); });
    }, { passive: true });
    if (prev) prev.addEventListener('click', () => go(index - 1));
    if (next) next.addEventListener('click', () => go(index + 1));
    thumbs.forEach((thumb, n) => thumb.addEventListener('click', () => go(n)));
    update();
  }

  // Pasek „Zamów” na dole chowa się, gdy sekcja zakupowa jest na ekranie (nie zasłania kafli ani „Kup teraz”).
  const bar = document.querySelector('.sticky-bar');
  const buyAreas = document.querySelectorAll('.ns-buy');
  if (bar && buyAreas.length && hasIO) {
    const seen = new Set();
    const barIO = new IntersectionObserver((entries) => {
      entries.forEach((entry) => (entry.isIntersecting ? seen.add(entry.target) : seen.delete(entry.target)));
      bar.classList.toggle('is-off', seen.size > 0);
    });
    buyAreas.forEach((area) => barIO.observe(area));
  }

  // Powrót przyciskiem „wstecz” z kasy: przycisk zakupu znowu aktywny.
  addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    document.querySelectorAll('.ns-buy-atc.is-loading').forEach((button) => {
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
      const label = button.querySelector('[data-ns-label]');
      if (label && label.dataset.text) label.textContent = label.dataset.text;
    });
  });

  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('video').forEach(forget));
  if (!observer) {
    addEventListener('scroll', schedule, { passive: true });
    addEventListener('resize', schedule);
  }
  document.addEventListener('visibilitychange', syncAll);
  addEventListener('pageshow', syncAll);

  // Autoplay odrzucony (np. tryb oszczędzania baterii): pierwsze dotknięcie lub klawisz uruchamia filmy, które powinny grać.
  const unlock = () => videos.forEach((video) => { const s = state.get(video); if (s && s.blocked) play(video); });
  ['pointerup', 'touchend', 'click', 'keydown'].forEach((type) => document.addEventListener(type, unlock, { capture: true, passive: true }));

  // Reduced motion: nic nie rusza się samo; dotknięcie filmu włącza lub zatrzymuje odtwarzanie.
  document.addEventListener('click', (event) => {
    if (!reduced.matches || !event.target.closest) return;
    const shell = event.target.closest('[data-ns-video]');
    const video = shell && shell.querySelector('video');
    const s = video && state.get(video);
    if (!s) return;
    s.chosen = video.paused;
    sync(video);
  });
  const onMotionChange = () => syncAll();
  if (reduced.addEventListener) reduced.addEventListener('change', onMotionChange);
  else if (reduced.addListener) reduced.addListener(onMotionChange);
})();
